import 'bootstrap/dist/css/bootstrap.min.css';
import Modal from 'react-bootstrap/Modal';

import 'bootstrap/dist/css/bootstrap.min.css';
import AddTenancyPatientForm from './AddTenancyPatientForm';
import { useClinicianProfile } from '../../hooks';
import { type AddPatientSetup } from '../../../lib';
import { useToast } from '../../../context';

interface AddPatientSetupModalProps {
  open: boolean;
  onSetOpen: (open: boolean) => void;
}
function AddPatientSetupModal({ onSetOpen, open }: AddPatientSetupModalProps) {
  const handleClose = () => {
    onSetOpen(false);
  };
  const { setToast } = useToast();

  const { selectedTenancy } = useClinicianProfile();
  const addPatientFeatures: AddPatientSetup | null =
    selectedTenancy?.features?.addPatientSetup || null;

  if (!addPatientFeatures || !addPatientFeatures.active) {
    setToast('This feature is not available for your tenancy');
    return null;
  }

  return (
    <Modal
      id="addPatientModal"
      show={open}
      onHide={handleClose}
      animation={false}
      size="lg"
      centered
    >
      <Modal.Header closeButton></Modal.Header>
      <Modal.Body>
        <AddTenancyPatientForm
          features={addPatientFeatures}
          handleClose={handleClose}
        />
      </Modal.Body>
    </Modal>
  );
}

export default AddPatientSetupModal;
